import { ITask, ITeam } from '../models';

export interface TaskAssignPermissions {
    assignAll: boolean;
    assignTeams: boolean;
}

export function deriveMyTeams(teams: Array<ITeam>, userId: string | undefined): Array<ITeam> {
    return teams.filter((team) => !team.default && (team.users ?? []).some((user) => user.id === userId));
}

export function deriveMyTeamIds(teams: Array<ITeam>, userId: string | undefined): Set<string> {
    return new Set(deriveMyTeams(teams, userId).map((team) => team.id));
}

export function isTaskAssignedToTeam(task: Pick<ITask, 'teamId'>, teamIds: ReadonlySet<string>): boolean {
    return !!task.teamId && teamIds.has(task.teamId);
}

export function canAssignTask(
    task: Pick<ITask, 'teamId'>,
    permissions: TaskAssignPermissions,
    myTeamIds: ReadonlySet<string>
): boolean {
    return permissions.assignAll || (permissions.assignTeams && isTaskAssignedToTeam(task, myTeamIds));
}
